import { nullishToOptional } from "../../../helpers";
import { Point2D } from "../primitives";
import { tokenAliasOrValue } from "./base";
import { ColorTokenData } from "./color";
import { z } from "zod";
export const GradientType = z.enum(["Linear", "Radial", "Angular"]);
export const GradientStop = z.object({
    position: z.number(),
    color: ColorTokenData,
});
export const GradientLayerValue = z.object({
    from: Point2D,
    to: Point2D,
    type: GradientType,
    aspectRatio: nullishToOptional(z.number()),
    stops: z.array(GradientStop).min(2),
});
export const GradientLayerData = tokenAliasOrValue(GradientLayerValue);
export const GradientTokenValue = z.array(GradientLayerData);
export const GradientTokenData = tokenAliasOrValue(GradientTokenValue);
